<template>
  <div>
    <Section v-if="!isLoadingTaxonomies">
      <template v-slot:section-header>
        <h5 class="title">ข้อมูล{{getProgramType()}}</h5>
      </template>
      <template v-slot:section-body>
        <form>
          <div class="row">
            <div class="col-md-8">
              <FormGroup :errorMessage="getErrorMessage('key')">
                <h5 class="name">คีย์</h5>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{baseURL}}</span>
                  </div>
                  <input
                    type="text"
                    placeholder="คีย์รายการ"
                    class="form-control"
                    :class="{'is-invalid': getErrorMessage('key')}"
                    :value="getProgramKey(currentProgram.programType)"
                    :disabled="currentProgram.programType==='season'"
                    @blur="$store.dispatch('setCurrentProgram', { key: $event.target.value })" />
                  <div
                    class="invalid-feedback"
                    v-if="getErrorMessage('key')">{{translateKeyError('key')}}</div>
                </div>
              </FormGroup>
              <FormGroup :errorMessage="getErrorMessage('title')">
                <h5 class="name">ชื่อ{{getProgramType()}}</h5>
                <input
                  type="text"
                  :placeholder="currentProgram.progromType === 'program' ? 'ชื่อรายการ' : 'ชื่อซีซั่น'"
                  class="form-control"
                  :class="{'is-invalid': getErrorMessage('title')}"
                  :value="currentProgram.title"
                  @blur="$store.dispatch('setCurrentProgram', { title: $event.target.value })" />
                <div
                  class="invalid-feedback"
                  v-if="getErrorMessage('title')">ระบุชื่อ{{getProgramType()}}</div>
              </FormGroup>
              <FormGroup>
                <h5 class="name">หมวดหมู่คอนเทนท์</h5>
                <SelectOptionObject
                  :class="{'is-invalid': getErrorMessage('contentCategory')}"
                  :options="contentCategories"
                  :disabledDeleteButton="true"
                  :allowEmpty="false"
                  :placeholder="'เลือกหมวดหมู่'"
                  :value="currentProgram.contentCategory"
                  @onChanged="onSelectedContentCategory"/>
                  <div
                    class="invalid-feedback"
                    v-if="getErrorMessage('contentCategory')">
                  {{getErrorMessage('contentCategory')}}
                </div>
              </FormGroup>
              <FormGroup>
                <h5 class="name">ประเภทรายการ</h5>
                <SelectOptionObject
                  :class="{'is-invalid': getErrorMessage('programCategory')}"
                  :options="programCategories"
                  :placeholder="currentProgram.progromType === 'program' ? 'เลือกประเภทรายการ' : 'เลือกประเภทซีซั่น'"
                  :value="currentProgram.programCategory"
                  @onChanged="onSelectedProgramCategory"/>
                  <div
                    class="invalid-feedback"
                    v-if="getErrorMessage('programCategory')">
                  {{getErrorMessage('programCategory')}}
                </div>
              </FormGroup>
              <FormGroup>
                <h5 class="name">แท็ก</h5>
                 <multiselect
                  :value="currentProgram.tags"
                  :options="tags"
                  :multiple="true"
                  :taggable="true"
                  :addTag="addTag"
                  @onSearch="loadTags"
                  @onChanged="(tags) => $store.dispatch('setCurrentProgram', { tags })" />
              </FormGroup>
            </div>
            <div class="col-md-4">
              <FormGroup>
                <h5 class="name">สถานะการเผยแพร่</h5>
                <ContentStatusManagement
                  :status="currentProgram.status"
                  :startPublish="currentProgram.startPublish"
                  :endPublish="currentProgram.endPublish"
                  :onChange="onChangeStatus" />
              </FormGroup>
              <FormGroup>
                <h5 class="name">สถานะการออกอากาศ</h5>
                <div class="form-check">
                  <input class="form-check-input"
                    type="radio"
                    :value="false"
                    :checked="!currentProgram.isOldProgram"
                    @change="$store.dispatch('setCurrentProgram', { isOldProgram: false })">
                  <label class="form-check-label">
                    กำลังออกอากาศ
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input"
                    type="radio"
                    :value="true"
                    :checked="currentProgram.isOldProgram"
                    @change="$store.dispatch('setCurrentProgram', { isOldProgram: true })">
                  <label class="form-check-label">
                    ยุติการออกอากาศแล้ว
                  </label>
                </div>
              </FormGroup>
              <FormGroup v-if="currentProgram && currentProgram.createdBy">
                <h5 class="name">สร้างโดย</h5>
                <EditorInformation :editor="currentProgram.createdBy" :timeStamp="currentProgram.createdAt" />
              </FormGroup>
              <FormGroup v-if="currentProgram && currentProgram.updatedBy">
                <h5 class="name">แก้ไขล่าสุดโดย</h5>
                <EditorInformation :editor="currentProgram.updatedBy" :timeStamp="currentProgram.updatedAt" />
              </FormGroup>
            </div>
          </div>
        </form>
      </template>
    </Section>
    <PreloaderSection
      v-if="isLoadingTaxonomies" />
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { loadTaxonomyByKey } from '@/taxonomy/api';
import FormGroup from '@/components/FormGroup.vue';
import Section from '@/components/Section.vue';
import SelectOptionObject from '@/components/SelectOptionObject.vue';
import Multiselect from '@/components/MultiSelect.vue';
import PreloaderSection from '@/components/PreloaderSection.vue';
import ContentStatusManagement from '@/contentStatus/ContentStatusManagement.vue';
import EditorInformation from '@/components/EditorInformation.vue';

export default {
  components: {
    Multiselect,
    FormGroup,
    Section,
    ContentStatusManagement,
    SelectOptionObject,
    PreloaderSection,
    EditorInformation,
  },
  data() {
    return {
      tags: [],
      contentCategories: null,
      programCategories: null,
      isLoadingTaxonomies: false,
    };
  },
  created() {
    this.load();
  },
  computed: {
    ...mapState({
      currentProgram: (state) => state.programItem.currentProgram,
      saveProgramState: (state) => state.programItem.saveProgramState,
    }),
    baseURL() {
      return process.env.VUE_APP_BASEURL || window.location.origin;
    },
  },
  methods: {
    async load() {
      try {
        this.isLoadingTaxonomies = true;
        await this.loadContentCategories();
        await this.loadProgramCategories();
        await this.loadTags();
        this.isLoadingTaxonomies = false;
      } catch (error) {
        this.isLoadingTaxonomies = false;
      }
    },
    async loadContentCategories() {
      const response = await loadTaxonomyByKey('content-category');
      this.contentCategories = response.data.data;
    },
    async loadProgramCategories() {
      const response = await loadTaxonomyByKey('program-category');
      this.programCategories = response.data.data;
    },
    async loadTags(filter) {
      const response = await loadTaxonomyByKey('tag', filter);
      this.tags = response.data.data;
    },
    onSelectedContentCategory(category) {
      if (category) {
        this.$store.dispatch('setCurrentProgram', { contentCategory: category, contentCategoryId: category.id });
      }
    },
    onSelectedProgramCategory(category) {
      if (category) {
        this.$store.dispatch('setCurrentProgram', { programCategory: category, programCategoryId: category.id });
      } else {
        this.$store.dispatch('setCurrentProgram', { programCategory: null, programCategoryId: null });
      }
    },
    translateKeyError() {
      const error = this.getErrorMessage('key');
      if (error === 'Key already exit') {
        return 'คีย์ซ้ำกับรายการในระบบ กรุณากรอกคีย์ใหม่';
      }
      return error;
    },
    addTag(tag) {
      this.tags.push(tag);
      this.$store.dispatch('setCurrentProgram', { tags: [...this.currentProgram.tags, tag] });
    },
    onChangeStatus(newStatus) {
      this.$store.dispatch('setCurrentProgram', {
        status: newStatus.status,
        startPublish: newStatus.startPublish,
        endPublish: newStatus.endPublish,
      });
    },
    getErrorMessage(fieldName) {
      return _.get(this.saveProgramState.error, `${fieldName}`, null);
    },
    getProgramKey(programType) {
      if (programType === 'season') {
        return `${this.currentProgram.key}/season/${this.currentProgram.seasonNumber}`;
      }
      return this.currentProgram.key;
    },
    getProgramType() {
      if (this.currentProgram.programType === 'program') {
        return 'รายการ';
      }
      return 'ซีซั่น';
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/form.scss';
@import './src/assets/scss/themes/components/section-container.scss';

.sync-status-container {
  margin-left: auto;
  display: flex;
  align-items: center;
}

</style>
